import { Phone, Mail, MapPin, Clock, Instagram, Facebook, Linkedin, MessageCircle } from "lucide-react";
import { buildWhatsAppUrl, trackEvent } from "@/lib/utm";
import SubscribeInline from "./SubscribeInline";

export default function Footer() {
  const wa = buildWhatsAppUrl(
    "5218116289267",
    "Hola Eclipse, vengo del sitio FlexShade."
  );
  return (
    <footer className="bg-[#0a0a0a] text-white/80 pt-16 pb-8 border-t border-white/10">
      <div className="container-x grid grid-cols-1 md:grid-cols-5 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img src="/images/logo_eclipse_oficial.png" alt="Eclipse" className="h-10 w-auto" />
            <span className="h-6 w-px bg-white/20" aria-hidden="true" />
            <img src="/brand/flexshade-logo.png" alt="FlexShade" className="h-7 w-auto" />
          </div>
          <p className="mt-2 text-orange-400 italic text-sm">Te dejamos cubierto.</p>
          <p className="text-sm text-white/60 leading-relaxed mt-4">
            Eclipse Cubiertas SA de CV — Líderes en techos de malla sombra y cubiertas modulares en Monterrey y el norte de México.
          </p>
          <div className="flex gap-3 mt-5">
            <a href="#" aria-label="Instagram" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:bg-white hover:text-black transition"><Instagram className="w-4 h-4"/></a>
            <a href="#" aria-label="Facebook" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:bg-white hover:text-black transition"><Facebook className="w-4 h-4"/></a>
            <a href="#" aria-label="LinkedIn" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:bg-white hover:text-black transition"><Linkedin className="w-4 h-4"/></a>
          </div>
          <div className="mt-6">
            <SubscribeInline />
          </div>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Contacto</h4>
          <ul className="space-y-3 text-sm">
            <li>
              <a
                href="tel:+528189899822"
                className="flex items-center gap-2 hover:text-white"
                onClick={() => trackEvent("phone_click", { location: "footer" })}
                data-testid="footer-call-btn"
              >
                <Phone className="w-4 h-4"/> Llámanos ahora
              </a>
            </li>
            <li>
              <a
                href={wa}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2 hover:text-white"
                onClick={() => trackEvent("whatsapp_click", { location: "footer" })}
                data-testid="footer-whatsapp-btn"
              >
                <MessageCircle className="w-4 h-4"/> Chatear por WhatsApp
              </a>
            </li>
            <li><a href="mailto:info@eclipsecubiertas.com" className="flex items-center gap-2 hover:text-white"><Mail className="w-4 h-4"/> info@eclipsecubiertas.com</a></li>
            <li className="flex items-start gap-2"><Clock className="w-4 h-4 mt-0.5"/> Lun-Vie 9:00-18:00 hrs</li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Dirección</h4>
          <a
            href="https://maps.google.com/?q=Carretera+Saltillo+308+Santa+Catarina+NL+66129"
            target="_blank"
            rel="noreferrer"
            className="flex items-start gap-2 text-sm hover:text-white"
          >
            <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0"/>
            <span>Carretera Saltillo #308<br/>Bodega 8, Pro vivienda del Poniente SE<br/>Santa Catarina, NL &middot; CP 66129</span>
          </a>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">FlexShade</h4>
          <ul className="space-y-2 text-sm">
            <li><a href="#modelos" className="hover:text-white">Los 5 Modelos</a></li>
            <li><a href="#caracteristicas" className="hover:text-white">Características</a></li>
            <li><a href="#proyectos" className="hover:text-white">Galería</a></li>
            <li><a href="#materiales" className="hover:text-white">Materiales</a></li>
            <li><a href="#catalogo" className="hover:text-white">Catálogo PDF</a></li>
            <li><a href="#cotizar" className="hover:text-white">Cotizar</a></li>
          </ul>
        </div>
      </div>

      <div className="container-x mt-12 pt-6 border-t border-white/10 text-xs text-white/50 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
        <p>© {new Date().getFullYear()} Eclipse Cubiertas SA de CV — Todos los derechos reservados</p>
        <div className="flex gap-5">
          <a href="#" className="hover:text-white">Política de privacidad</a>
          <a href="#" className="hover:text-white">Aviso legal</a>
        </div>
      </div>
    </footer>
  );
}
